import React from 'react'
import InputTextField from './InputTextField'

const InputSearch = (props) => {
  return (
    <InputTextField
      size="small"
      label="Recherche"
      inputProps={{
        maxLength: 20
      }}
      {...props}
    />
  )
}

export default InputSearch
